import { render, staticRenderFns } from "./PortfolioXDCValues.vue?vue&type=template&id=ce77c8ae&scoped=true&"
import script from "./PortfolioXDCValues.vue?vue&type=script&lang=ts&"
export * from "./PortfolioXDCValues.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioXDCValues.vue?vue&type=style&index=0&id=ce77c8ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce77c8ae",
  null
  
)

export default component.exports